import { withFormik } from 'formik'
import React, { useEffect } from 'react'
import Button from '../../../../Components/Button'
import Field from '../../../../Components/Formik/Field'
import Form from '../../../../Components/Formik/Form'
import { TERMS_CONDITIONS_DOCUMENT_TYPES } from '../../../../Util/Options'

function TermsConditionFilter({ values, setValues, filterData }) {
  useEffect(() => {
    setValues({ ...values, ...filterData })
  }, [])

  return (
    <Form>
      <div className="form-fields">
        <Field as="select" name="type" label="Document Type" options={TERMS_CONDITIONS_DOCUMENT_TYPES} />
      </div>
      <div className="form-fields">
        <Field as="date" name="validFrom" label="Valid From" />
      </div>
      <div className="form-fields">
        <Field as="date" name="validTo" label="Valid To" />
      </div>
      <div className="form-fields">
        <Button type="submit" variant="secondary" className="search">
          <i className="flaticon-search-interface-symbol" /> Search
        </Button>
        <Button type="reset" className="btn-block btn-glow search">
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues: () => ({
    type: '',
    validFrom: '',
    validTo: ''
  }),
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values)
})(TermsConditionFilter)
